class RecentlyViewedWrapper extends HTMLElement {
    constructor() {
        super();
    }

    async connectedCallback() {
        const renderContainerSelector = this.getAttribute('data-render-container-id');
        if (!renderContainerSelector) {
            this.hide();
            return;
        }

        this.renderContainer = window.document.getElementById(renderContainerSelector);
        if (!this.renderContainer) {
            this.hide();
            return;
        }

        const currentPdpSelector = window.document.querySelector('product-info[data-product-handle]');
        this.currentPdpHandle = currentPdpSelector?.getAttribute('data-product-handle');

        const handles = this.getCookie();
        this.handles = handles.split(',').reverse();

        if (this.currentPdpHandle && this.currentPdpHandle !== '')
            this.handles = this.handles.filter((handle) => handle !== this.currentPdpHandle);

        if (this.handles.length > 0) await this.fetchProduct();
        else this.hide();
    }

    async fetchProduct() {
        try {
            const aspectRatio = this.renderContainer?.dataset.settingsRatio;
            const imageShape = this.renderContainer?.dataset.settingsShape;
            const sectionId = this.renderContainer?.dataset.settingsSection;
            const colorScheme = this.renderContainer?.dataset.colorScheme;
            const quickAdd = this.renderContainer?.dataset.settingsQuickAdd;
            const showVendor = this.renderContainer?.dataset.settingsVendor;
            const containerClasses = this.renderContainer?.dataset.settingsClasses;
            const containerId = this.renderContainer?.dataset.settingsId;
            let paginate = this.renderContainer?.dataset.settingsPaginate;
            paginate = paginate ? parseInt(paginate, 10) : 12;

            const queryContent = this.handles
                .slice(0, paginate)
                .map(
                    (handle, index) => `
                    product${index}: product(handle: "${handle}"){
                        ${window.ShopifyStorefront.productQuery()}
                    }`,
                )
                .join('\n');

            const query = `
                query getProducts($language: LanguageCode!, $country: CountryCode!)@inContext(country: $country, language: $language){
                    ${queryContent}
                }`;
            const variables = {
                language: Shopify.locale.toUpperCase(),
                country: Shopify.country,
            };
            const responseResults = await window.ShopifyStorefront.executeQuery(query, variables);
            const results = Object.values(responseResults.data)
                .filter(Boolean)
                .filter((p) => p.availableForSale);

            if (results.length < 1) {
                this.hide();
                return;
            }

            const productsMarkup = results
                .map((node, index) =>
                    window.ShopifyStorefront.productCardMarkup({
                        node,
                        aspectRatio,
                        imageShape,
                        sectionId,
                        colorScheme,
                        quickAdd,
                        showVendor,
                        containerClasses,
                        containerId: containerId + (index + 1),
                    }),
                )
                .join('');

            this.renderContainer.innerHTML = productsMarkup;
            this.renderContainer?.closest('slider-component').initSlider();
            this.show();
        } catch (error) {
            console.error(error);
            this.hide();
        }
    }

    hide() {
        this.style.display = 'none';
    }
    show() {
        this.style.display = 'block';
    }

    getCookie() {
        const name = 'shopify_recently_viewed';
        let cookieArr = document.cookie.split(';');
        for (let i = 0; i < cookieArr.length; i++) {
            let cookie = cookieArr[i].trim();
            if (cookie.indexOf(name + '=') == 0) {
                return cookie.substring(name.length + 1, cookie.length);
            }
        }
        return '';
    }
}

customElements.define('recently-viewed-wrapper', RecentlyViewedWrapper);
